import {
  ACTIVO_BOLETINES,
  ALL_BOLETINES,
  LOADING_ALL_BOLETINES,
} from './BoletinesReducer';
import { allBoletinesService, oneBoletinesService } from './BoletinesService';

export const allBoletinesAction = async (dispatch, params) => {
  dispatch({ type: LOADING_ALL_BOLETINES, payload: true });
  const res = await allBoletinesService(params);
  dispatch({ type: ALL_BOLETINES, payload: res.data.data });
  dispatch({ type: LOADING_ALL_BOLETINES, payload: false });
  return res.data;
};

export const setActivoBoletinesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_BOLETINES, payload: data });
};

export const oneBoletinesAction = async (dispatch, id) => {
  const res = await oneBoletinesService(id);
  await setActivoBoletinesAction(dispatch, res.data);
  return res.data;
};
